import { createStackNavigator } from '@react-navigation/stack'
// import DownloadReports from '../../screens/DownloadReports'
import { Payments } from '../../screens/Payments'

const PaymentsStack = () => {
  const Stack = createStackNavigator()
  return (
    <Stack.Navigator
      screenOptions={{ headerBackTitleVisible: false, headerShown: false, headerMode: 'screen' }}
      initialRouteName={'payments'}>
      <Stack.Screen name="payments" component={Payments} />
      {/* <Stack.Screen name={'txns-download'} component={DownloadReports} options={{ headerShown: true }} /> */}
      {/* <Stack.Screen
        name={'settlements-download'}
        component={DownloadReports}
        options={{ headerShown: true }}
        initialParams={{ isSettlement: true }}
      /> */}
    </Stack.Navigator>
  )
}

export default PaymentsStack
